/* eslint-disable no-case-declarations */
import { route } from 'quasar/wrappers';
import {
    createMemoryHistory,
    createRouter,
    createWebHashHistory,
    createWebHistory,
} from 'vue-router';
import { Store } from 'src/store';
import {
    ruleServerWorks,
} from './rules/system';
import {
    ruleCampusZone,
} from './rules/campus';
import {
    ruleAdmin,
    ruleEnsureAuth,
    ruleExternal,
} from './rules/auth';
import {
    ruleRefreshUser,
} from './rules/user';
import {
    rulePortfolioBreak,
    ruleCodeHub,
    ruleTemporaryUserRedirect,
    ruleUserRedirect,
    ruleCompetenciesLocalMode,
} from './rules/navigation';
import { trackRecentEntities } from './rules/recentEntities';
import { STOP_NAVIGATION } from './rules/constants';
import routes from './routes';

const ROUTER_MODE_HISTORY = 'history';
const MODE_SSR = 'ssr';
const SCROLL_TO_TOP_LEFT = { left: 0, top: 0 };
const ROUTER_RULES = [
    ruleCampusZone, // граница кампусной зоны: /campus/* дальше по цепочке не идёт
    ruleServerWorks, // серверные работы
    ruleTemporaryUserRedirect, // временные ссылки в ЛК
    ruleExternal, // админские роуты
    ruleAdmin, // админские роуты
    ruleTemporaryUserRedirect, // временные ссылки в ЛК
    ruleEnsureAuth, // проверка авторизации
    ruleRefreshUser, // обновление пользователя
    rulePortfolioBreak, // проверка на портфолио
    ruleCodeHub, // проверка на codehub
    ruleUserRedirect, // редиректы для пользователя
    ruleCompetenciesLocalMode, // проверка на локальный режим компетенций
];

async function runRules (rules, ctx) {
    for (const rule of rules) {
        // eslint-disable-next-line no-await-in-loop
        const result = await rule(ctx);

        if (result === STOP_NAVIGATION) {
            return STOP_NAVIGATION;
        }

        if (result) {
            return result;
        }
    }

    return false;
}

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(() => {
    // app-vite 3 выпилил поддержку Vuex, поэтому store больше не инжектится в
    // route()/boot(). Берём синглтон Store напрямую (см. src/boot/boot.js -> app.use).
    const store = Store;

    // eslint-disable-next-line no-nested-ternary
    const createHistory = process.env.SERVER
        ? createMemoryHistory
        : (process.env.VUE_ROUTER_MODE === ROUTER_MODE_HISTORY ? createWebHistory : createWebHashHistory);

    const Router = createRouter({
        scrollBehavior: () => SCROLL_TO_TOP_LEFT,
        routes,
        // eslint-disable-next-line no-void
        history: createHistory(process.env.MODE === MODE_SSR ? void 0 : process.env.VUE_ROUTER_BASE),
    });

    // vue-router 5: колбэк next() задепрекейчен — гварды возвращают значение
    // (true/undefined = продолжить, false = отмена, объект/строка = редирект).
    Router.beforeEach(async (to, from) => {
        const ctx = {
            to,
            from,
            store,
            user: store.state.pages?.user,
        };

        const result = await runRules([
            ...ROUTER_RULES,
        ], ctx);

        if (result === STOP_NAVIGATION) {
            return false;
        }

        if (result) {
            return result;
        }

        return true;
    });

    // Пишем «последние открытые» курсы/пакеты после перехода, чтобы не блокировать навигацию.
    Router.afterEach((to) => {
        trackRecentEntities(to);
    });

    return Router;
});
